module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-form-file', {
    staticStyle: {
      "height": "80px",
      "background": "transparent",
      "width": "100%"
    },
    attrs: {
      "otherDocName": _vm.otherDocName,
      "documentLink": _vm.documentLink,
      "folderName": 'Expense',
      "accept": '*',
      "id": "MultiFileUploader",
      "documentName": _vm.documentName,
      "multiple": _vm.multiple,
      "fileAllModuleId": _vm.fileAllModuleId,
      "assign_no": _vm.assign_no,
      "drop-placeholder": "Drop file here...",
      "plain": ""
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm._v(" "), _vm._l((_vm.uploadedFiles), function(ufile, uindex) {
    return _c('div', {
      key: uindex
    }, [(_vm.assign_no) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.viewDoc(ufile)
        }
      }
    }, [_vm._v("--View Document - " + _vm._s(uindex + 1))]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.files), function(file, index) {
    return _c('div', {
      key: index
    }, [_c('div', [_vm._v(_vm._s(file.name))]), _vm._v(" "), (file.progress > 0) ? _c('b-progress', {
      attrs: {
        "variant": 'success',
        "value": file.progress,
        "max": 100,
        "show-progress": "",
        "animated": ""
      }
    }) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8452b98e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/MultiFileUploader.vue
// module id = 2789
// module chunks = 0